module.exports = __webpack_public_path__ + "static/coming-soon-fc46124396ef2dd2902bda0854c7534c.png";